import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('CatalogStatus?page=' + page, {params});
    },
    getByUser() {
        return Service().get('CatalogStatusByUser');
    }, 
    show(id) {
        return Service().get('CatalogStatus/show/'+id);
    },    
    create(params) {
        return Service().post('CatalogStatus/create', params);
    },
    update(id, params) {
        return Service().post('CatalogStatus/update/'+id, params);
    },
    delete(id) {
        return Service().post('CatalogStatus/delete/'+id);
    }
}